import React, { useState, useEffect } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useDataTableContext } from '../../../Contexts/DataTableContext';
import { formatMoney } from '../../../../utils/money';
import moment from "moment-timezone";

import { useSelector, useDispatch } from 'react-redux';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { SUBSCRIPTIONS_TABLE_CONFIG } from '../../../../Constants/datatables';
import { useTranslation } from 'react-i18next';

function SubscriptionsDatatable() {
    const { t, i18n } = useTranslation();
    const { totalRecords, loading, lazyParams, setLazyParams, data, onPage } = useDataTableContext();
    const dispatch = useDispatch()
    const { openDialog, subscriptionInfo, companyDetails } = useSelector((state) => state.global);

    useEffect(() => {
        setLazyParams(prev => ({ ...prev, ...SUBSCRIPTIONS_TABLE_CONFIG }))
    }, [])

    const periodBodyTemplate = (rowData) => {
        let startDate = moment(rowData?.start_date);
        let endDate = moment(rowData?.end_date);
        let period = endDate.diff(startDate, 'days');

        return (
            <div className=''>
                <span className="text-center text-capitalize" >
                    {`${period}   Day${period > 1 ? "s" : ""}`}
                </span>
            </div>
        );
    }

    // Table body columns templates 
    const statusBodyTemplate = (rowData) => {
        return (
            <span
                className={`text-center badge ${{
                        ACTIVE: "bg-label-success",
                        INACTIVE: "bg-label-danger",
                        PENDING: "bg-label-warning",
                        CANCELLED: "bg-label-secondary",
                    }[rowData.status] || "bg-label-secondary"
                    }`}
            >
                {rowData.status.toLowerCase()}
            </span>

        );
    }

    // The price of a grant is shown ONLY when the admin stored a currency with it; legacy
    // (Stripe-era, USD) rows and gifts show no amount. No invoice documents for customers.
    const amountBodyTemplate = (rowData) => formatMoney(rowData.paid_price, rowData.currency, i18n.language) || '—'

    return (
        <>
            <div className='table-responsive text-nowrap w-100 rounded-[30px] stream_datatable position-relative'>
                {subscriptionInfo.isFinished &&
                    <div className='position-absolute w-100 h-100 top-0 left-0 bg-white-opacity zindex-1'></div>
                }

                <DataTable value={data?.subscriptions} lazy responsiveLayout="scroll" dataKey="id"
                    paginator first={lazyParams.first} rows={lazyParams.rows}
                    totalRecords={totalRecords} onPage={onPage}
                    loading={loading} className="table text-light"
                >
                    <Column field="title" header={t('billing.col_plan_name')} className='text-center fs-8' />
                    <Column field="paid_price" header={t('billing.col_amount')} className='text-center fs-8' body={amountBodyTemplate} />
                    <Column field="period" header={t('billing.period_label')} className='text-center fs-8' body={periodBodyTemplate} />
                    <Column field="number_of_devices" header={t('billing.col_no_of_devices')} className='text-center fs-8' />
                    <Column field="status" header={t('table.status')} className='text-center fs-8' body={statusBodyTemplate} />
                    <Column field="start_date" header={t('billing.col_start_date')} className='text-center fs-8' />
                    <Column field="end_date" header={t('billing.col_end_date')} className='text-center fs-8' />
                </DataTable>
            </div>

        </>
    )
}

export default SubscriptionsDatatable